import OnboardingBody from "../components/OnboardingBody";
import OnboardingSidebar from "../components/OnboardingSidebar";
import Add from "./components/Add";
import Error from "./components/Error";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { FC, useMemo } from "react";
import { withErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { Route, Routes, useNavigate } from "react-router-dom";
import card from "~@/assets/image/svg/onboarding/card.svg";
import Loader from "~@/components/base/Loader";
import TechnicalError from "~@/components/layout/TechnicalError";
import {
  OrganizationStatus,
  useGetOrganizationsQuery,
} from "~@/graphql/codegen/generated";
import { ArrowLeft14x14Icon } from "~@/icons";

const PaymentMethod: FC = () => {
  const { t } = useTranslation();

  const { data: organizationsData } = useGetOrganizationsQuery();

  const currentOrganization = useMemo(() => {
    return organizationsData?.getOrganizations?.current;
  }, [organizationsData]);

  const isTrial = useMemo(() => {
    return currentOrganization?.isTrial;
  }, [currentOrganization]);

  const isInactive = useMemo(() => {
    return (
      (currentOrganization?.status === OrganizationStatus.Inactive &&
        (currentOrganization.isCanceled ||
          currentOrganization.isPaymentFailed)) ??
      false
    );
  }, [currentOrganization]);

  const navigate = useNavigate();

  return (
    <div className="onboarding-container">
      <OnboardingSidebar showSteps={!isInactive}>
        <div className="block block--has-mb-20">
          <figure className="image image--is-auto">
            <img src={card} alt="card icon" />
          </figure>
        </div>
        <div className="block block--has-mb-13">
          <h1 className="onboarding__title">
            {t("onboarding.title.payment-method")}
          </h1>
        </div>
        <div className="block">
          <span className="onboarding__description">
            {t("onboarding.description.payment-method")}
          </span>
        </div>
      </OnboardingSidebar>
      <OnboardingBody>
        <div className="hero hero--is-fullheight">
          {!isInactive && isTrial && (
            <div className="hero__header">
              <a
                href="#back"
                className="packages-settings__link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(-1);
                }}
              >
                <div className="icon-text icon-text--has-gap-6">
                  <span className="icon icon--is-24x24">
                    <ArrowLeft14x14Icon />
                  </span>
                  <span>{t("action.go-back")}</span>
                </div>
              </a>
            </div>
          )}
          <div className="hero__body">
            <div className="container container--is-centered container--is-v-centered container--has-text-centered">
              <Routes>
                <Route index element={<Add />} />
                <Route path="error" element={<Error />} />
              </Routes>
            </div>
          </div>
        </div>
      </OnboardingBody>
    </div>
  );
};

export default withAuthenticationRequired(
  withErrorBoundary(PaymentMethod, {
    FallbackComponent: () => <TechnicalError />,
  }),
  {
    onRedirecting() {
      return <Loader isFullHeight />;
    },
  }
);
